// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__vXPd8","additionalInfo":"AgreementModal_additionalInfo__pTS9D"};